/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Intensity_Factor_One_LinerInputs */

const en_exp_intensity_factor_one_liner = /** @type {(inputs: Exp_Intensity_Factor_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How hard the ride was compared to your FTP — your Normalized Power divided by FTP.`)
};

const de_exp_intensity_factor_one_liner = /** @type {(inputs: Exp_Intensity_Factor_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie hart die Fahrt im Vergleich zu deiner FTP war — Normalisierte Leistung geteilt durch FTP.`)
};

/**
* | output |
* | --- |
* | "How hard the ride was compared to your FTP — your Normalized Power divided by FTP." |
*
* @param {Exp_Intensity_Factor_One_LinerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_intensity_factor_one_liner = /** @type {((inputs?: Exp_Intensity_Factor_One_LinerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Intensity_Factor_One_LinerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_intensity_factor_one_liner(inputs)
	return de_exp_intensity_factor_one_liner(inputs)
});